import { render, staticRenderFns } from "./FactsPageList.vue?vue&type=template&id=26d21666&scoped=true&"
import script from "./FactsPageList.vue?vue&type=script&lang=js&"
export * from "./FactsPageList.vue?vue&type=script&lang=js&"
import style0 from "./FactsPageList.vue?vue&type=style&index=0&id=26d21666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d21666",
  null
  
)

export default component.exports